// External
import React from 'react';
import PropTypes from 'prop-types';

// Internal
import Button from 'ui/new/button';
import { DisableAlert } from './DisableAlert';
// Styles
import style from './ListTitle.scss';

const ListTitle = ({ onOpenModal }) => (
  <div>
    <DisableAlert />
  <div className={style.header}>
    <span>Campanhas de e-mail</span>
    <div className={style.header__actions}>
      <Button onClick={onOpenModal} type="primary" disabled>
        CRIAR CAMPANHA DE E-MAIL
      </Button>
    </div>
  </div>
  </div>
);

ListTitle.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
};

export default ListTitle;
